export const useBarChart = () => {
  const setupBarChart = (element: HTMLElement, value: number, max: number): void => {
    const percent = Math.min(100, Math.max(0, (value / max) * 100)).toFixed(1);
    const fill = element.querySelector(".bar-chart__fill") as HTMLElement;
    const label = element.querySelector(".bar-chart__value") as HTMLElement;

    if (fill) {
      fill.style.setProperty("--bar-chart-value", `${percent}%`);
    }

    if (label) {
      // Toggle --value-low class based on percent to make the label appear over the bar
      element.classList.toggle("bar-chart--value-low", parseInt(percent) < 25);
      
      label.textContent = value.toString();
    }
  };

  return {
    setupBarChart
  };
};
